import * as React from 'react';
import { DatePicker } from 'antd';
import { DateTime } from 'luxon';

import { luxonToMoment, momentToLuxon } from 'core/utils/zoomTime';

interface IZoomDatePickerProps {
  value: DateTime;
  onChange: (date: DateTime) => void;
  disabled?: boolean;
}

/** Single-date picker bound to luxon DateTime (Europe/Warsaw). */
export const ZoomDatePicker = ({
  value,
  onChange,
  disabled,
}: IZoomDatePickerProps) => (
  <DatePicker
    allowClear={false}
    disabled={disabled}
    format="YYYY-MM-DD"
    value={luxonToMoment(value) ?? undefined}
    onChange={(next) => {
      const dt = momentToLuxon(next);
      if (dt) {
        onChange(dt);
      }
    }}
  />
);
